import React, { useState } from 'react';
import { Nullable } from 'global';
import { Theme } from '@mui/material/styles';
import moment, { Moment } from 'moment/moment';
import makeStyles from '@mui/styles/makeStyles';
import { Box, Typography } from '@mui/material';
import { isNullOrUndefined } from 'utils/typeGuargs';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { EquipmentDynamicFieldsProps } from '../../../types';
import { RenderWithCondition } from '../../../../../components/shared/Conditional/RenderWithCondition';

export const InServiceDateField = ({
  label,
  fact,
  error,
  value,
  onChange,
  helperText,
}: EquipmentDynamicFieldsProps) => {
  const classes = useStyles({ error: !!error });

  const [datePickerValue, setDatePickerValue] = useState<Nullable<Moment>>(null);

  const onPickerChange = (value: Nullable<Moment>) => {
    setDatePickerValue(value);
    const months = getMonthsDifference(value);

    if (isNullOrUndefined(months)) onChange('');
    else onChange(months);
  };

  return (
    <Box className={classes.wrapper}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DatePicker
          value={datePickerValue}
          onChange={onPickerChange}
          label={label ?? fact.factKey.replace(/_/g, ' ')}
          slotProps={{
            textField: {
              error,
              fullWidth: true,
              helperText: error ? helperText : '',
            },
          }}
        />
      </LocalizationProvider>

      <RenderWithCondition condition={value !== ''}>
        <Box className={classes.monthsBadge}>
          <Typography>
            {value ?? '-'} {Number(value) === 1 ? 'month' : 'months'}
          </Typography>
        </Box>
      </RenderWithCondition>
    </Box>
  );
};

function getMonthsDifference(date: Moment | null) {
  if (!date) return null;

  const today = moment().startOf('day');
  const startOfDay = moment(date).startOf('day');

  const exactMonths = today.diff(startOfDay, 'months', true);

  return Math.floor(exactMonths);
}

const useStyles = makeStyles<Theme, { error: boolean }>(({ palette }) => ({
  wrapper: {
    gap: '0.5rem',
    display: 'grid',
    alignItems: 'baseline',
    gridTemplateColumns: '1fr auto',
  },
  monthsBadge: {
    display: 'flex',
    minWidth: '4rem',
    padding: '4px 8px',
    borderRadius: '4px',
    alignItems: 'center',
    height: 'fit-content',
    justifyContent: 'center',
    border: ({ error }) => `1px solid ${error ? palette.error.main : palette.common.black}`,
  },
}));
